<!-- FOR DEMO ONLY -- REMOVE ME -->
<div style="position: absolute; top: 10px; width: 300px; left: 45%;background: #f4f4f4; padding: 4px; border-radius:
3px;">
  <div class="flex flex-both-center">
    <small class="d-b p-l-r-10">Product:</small>
    <nz-select nzShowSearch  [(ngModel)]="productType" style="width: 100%" (ngModelChange)="handleStateChange(productType)">
      <nz-option [nzLabel]="'Life Claim'" [nzValue]="'claims-life'"></nz-option>
      <nz-option [nzLabel]="'Health Claim'" [nzValue]="'claims-health'"></nz-option>
      <nz-option [nzLabel]="'Health Proposal'" [nzValue]="'underwriting-health'"></nz-option>
    </nz-select>
  </div>
</div>
<!-- / FOR DEMO ONLY -- REMOVE ME -->

<div class="m-b-20">
  <div class="flexie-auto-grid">
    <!-- Search -->
    <div>

      <div>
        <h3>Search</h3>
        <!-- <app-ui-search searchables="['Claim Number','Policy Number','Insured Name']"></app-ui-search> -->
      </div>

    </div>
    <!-- Inbox Type Switcher: My/Subordinate/Team -->
    <div class="text-a-right">
      <h3>Inbox</h3>
      <nz-radio-group [(ngModel)]="radioValue" [nzButtonStyle]="'solid'" [nzSize]="'default'">
        <label nz-radio-button nzValue="myCases" (click)="loadCases('myCases')"><i nz-icon nzType="user" nzTheme="outline"></i> My Cases</label>
        <label nz-radio-button nzValue="subCases" (click)="loadCases('subCases')"><i nz-icon nzType="usergroup-add" nzTheme="outline"></i> Subordinate Cases</label>
        <label nz-radio-button nzValue="teamCases" (click)="loadCases('teamCases')"><i nz-icon nzType="team" nzTheme="outline"></i> Team Cases</label>
      </nz-radio-group>
    </div>
  </div>
</div>

<div class="inbox-grid">
  <!-- Tree Block -->
  <div class="inbox-tree">
    <nz-tree [nzData]="nodes" nzShowIcon="true" (nzClick)="treeClick($event)"></nz-tree>
  </div>

  <!-- Items Block -->
  <div>
    <div nz-row *ngFor="let item of list | slice:0:10; index as i;">
    <div nz-col nzSpan="24" class="task-item shadowed-on-hover">

      <nz-skeleton [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="isLoading">

      <div class="task-item-grid">
        <div>
          <div class="task-item-block">
          <span class="f-s-1-1r">
            <ng-container [ngSwitch]="productType">
              <span *ngSwitchCase="'claims-life'">
                <b>#CLM00{{i+3}}107{{i*2}}</b>&nbsp;
                <nz-tag [nzColor]="'blue'">Death Claim</nz-tag>
                <nz-tag  [nzColor]="'green'"><i nz-icon nzType="heart"></i> StandardLife</nz-tag>
              </span>
              <span *ngSwitchCase="'claims-health'">
                <b>#CLM00{{i+3}}107{{i*2}}</b>&nbsp;
                <nz-tag [nzColor]="'blue'">Health Claim</nz-tag>
                <nz-tag [nzColor]="'orange'"><i nz-icon nzType="heart"></i> StandardHealth</nz-tag>
              </span>
              <span *ngSwitchCase="'underwriting-health'">
                <b>PP0090{{i*2}}/9{{i+2}}{{i*2}}/HL172</b>&nbsp;
                <nz-tag [nzColor]="'blue'">Health Proposal</nz-tag>
                <nz-tag [nzColor]="'green'"><i nz-icon nzType="heart"></i> StandardHealth</nz-tag>
              </span>
            </ng-container>
          </span>
          </div>

          <div class="grid grid-3x grid-gap-10 p-t-b-10" *ngIf="productType=='claims-life' || productType=='claims-health'">
            <div><strong class="c-s-heading">Policy Number</strong> P00{{i+17}}30547{{i+9}}</div>
            <div><strong class="c-s-heading">Policy Owner</strong> Chris Hemsworth</div>
            <div><strong class="c-s-heading">Claim Number</strong> CLM00{{i+3}}107{{i*2}}</div>
            <div><strong class="c-s-heading">Policy Commencement</strong> 12 Nov 2018, 10:15 AM</div>
            <div><strong class="c-s-heading">Insured Name</strong> Chris Hemsworth</div>
            <div><strong class="c-s-heading">Claimed Amount </strong> Rs. 1.{{i+1}}0 Cr</div>
          </div>
          <div class="grid grid-3x grid-gap-10 p-t-b-10" *ngIf="productType=='underwriting-health'">
            <div><strong class="c-s-heading">Proposal Number</strong> PP0090{{i*2}}/9{{i+2}}{{i*2}}/HL172</div>
            <div><strong class="c-s-heading">Stage</strong> Pending Manual Underwriting</div>
            <div><strong class="c-s-heading">Submission Date</strong> 12 Nov 2018, 10:15 AM</div>
            <div><strong class="c-s-heading">Status</strong>  Data entry complete</div>
            <div><strong class="c-s-heading">Premium </strong> Rs. {{i*2+5}}0,000</div>
            <div><strong class="c-s-heading">Premium Status </strong> <nz-tag [nzColor]="'#d1861b'">Outstanding</nz-tag></div>
          </div>

          <!--
                      <div class="task-item-block">
                        Sum Insured: Rs. 1.20 Cr &bull; Premium: Rs 10.5 L
                      </div>
                      <div class="task-item-block">
                        Primary Insured: <nz-avatar nzSize="small" nzIcon="anticon anticon-user"></nz-avatar> Chris Hemsworth &bull; Policy Owner: Chris Hemsworth
                      </div>
          -->
        </div>

        <div class="tags-equi-width">
          <nz-tag class="d-b w-100-pc" [nzColor]="'red'">SLA: Expired</nz-tag>
          <nz-tag class="d-b w-100-pc">Complexity: 8</nz-tag>
          <nz-tag class="d-b w-100-pc">Priority: 5</nz-tag>
        </div>

        <div>
          <button nz-button nzType="default" class="w-100-pc b-r-0" [routerLink]="'/app/claims/details/adjudication/'+productType"><i nz-icon nzType="eye" nzTheme="outline"></i> Open</button>
          <button nz-button nzType="primary" class="w-100-pc b-r-0" (click)="item.isCollapsed=!item.isCollapsed"><i nz-icon nzType="safety" nzTheme="outline"></i> Analyze</button>
        </div>
      </div>

      <div *ngIf="!item.isCollapsed">
        <!-- <app-ui-analytics-tab></app-ui-analytics-tab> -->
      </div>

      <div class="task-item-foot">
        <span>Created: 07 Apr 2019 (3 days ago)</span>
        <span>Last Re-assigned by: Mathew Perry</span>
        <span>Assigned to: John Doe (You)</span>
      </div>

    </nz-skeleton>

    </div>
    </div>
  </div>
</div>

<div class="pagination-inbox text-a-center">
  <nz-pagination [nzPageIndex]="1" [nzTotal]="300" nzShowSizeChanger [nzPageSize]="10"></nz-pagination>
</div>

